import { useEffect, useState, useContext, useRef } from "react";
import { FaSearch, FaCalendarAlt, FaBell } from "react-icons/fa";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import AppContext from "../../../context/AppContext";
import echo from "../../../echo";
import "../../../assets/css/Customer/general/MyHeader.css";

const MyHeader = ({ screenName }) => {
  const navigate = useNavigate();
  const { authToken } = useContext(AppContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const channelRef = useRef(null);
  const isFirstCleanup = useRef(true);

  useEffect(() => {
    const token = authToken || localStorage.getItem("authToken");
    if (!token) {
      return;
    }

    let customerId = null;
    try {
      const decoded = jwtDecode(token);
      customerId = decoded.sub || decoded.id;
    } catch (err) {
      console.log("Token decode failed:", err.message);
      return;
    }

    if (!customerId) {
      return;
    }

    const channelName = `customer-notifications.${customerId}`;
    const channel = echo.channel(channelName);
    channelRef.current = channelName;

    channel.listen('.new-notification', (data) => {
      setUnreadCount((prev) => prev + 1);

      const audio = new Audio('/notification-sound.mp3');
      audio.play().catch((err) => console.log("Ringtone play blocked:", err.message));
    });

    return () => {
      if (isFirstCleanup.current) {
        isFirstCleanup.current = false;
        return;
      }
      if (channelRef.current) {
        echo.leaveChannel(channelRef.current);
        channelRef.current = null;
      }
    };
  }, [authToken]);

  return (
    <div className="CustomerDashboard-header">
      <div className="CustomerDashboard-header-inner">
        <div className="CustomerDashboard-logo">
          <h1 className="CustomerDashboard-logo-text">{screenName}</h1>
        </div>

        <button
          className="CustomerDashboard-bell-btn"
          onClick={() => navigate("/customer-notifications")}
          style={{ position: 'relative' }}
        >
          <FaBell size={20} color="#ffffff" />
          {unreadCount > 0 && (
            <span
              style={{
                position: 'absolute',
                top: '-2px',
                right: '-2px',
                backgroundColor: '#ff3b30',
                color: '#fff',
                borderRadius: '50%',
                fontSize: '10px',
                width: '16px',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {unreadCount}
            </span>
          )}
        </button>
      </div>

      {screenName === "TrustiDrive" ? (
        <div className="CustomerDashboard-search-wrapper">
          <InputGroup className="CustomerDashboard-search-group">
            <InputGroup.Text className="CustomerDashboard-search-icon">
              <FaSearch size={18} color="#6c757d" />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search destinations"
              className="CustomerDashboard-search-input"
            />
            <InputGroup.Text
              className="CustomerDashboard-search-calendar"
              onClick={() => navigate("/Customerdate-time-schedule")}
              style={{ cursor: "pointer" }}
            >
              <FaCalendarAlt size={18} color="#6c757d" />
            </InputGroup.Text>
          </InputGroup>
        </div>
      ) : null}
    </div>
  );
};

export default MyHeader;